export default "__VITE_ASSET__BtSXGj5a__"